/* eslint no-unused-vars: ["error", { "ignoreRestSiblings": true }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import cx from 'classnames';
import { requestTaskList } from 'actionCreators';
import { getTaskList } from '../../../../reducers';
import ReactSelect from 'components/StyledSelect/react_select';
import reactSelectStyles from 'components/ReactSelect/styles';

class TaskSelect extends Component {
  componentDidMount() {
    if (!this.props.loaded) {
      this.props.requestTaskList();
    }
  }

  render() {
    const { className, loaded, ...props } = this.props;
    return (
      <ReactSelect
        multi
        resetValue={[]}
        name="task"
        className={cx(reactSelectStyles, className)}
        label="Tasks"
        placeholder="All Tasks"
        {...props}
      />
    );
  }
}

TaskSelect.propTypes = {
  taskOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.number,
  })),
  value: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  loaded: PropTypes.bool.isRequired,
  requestTaskList: PropTypes.func.isRequired,
};

const getTaskOptions = createSelector(
  getTaskList,
  tasks => tasks.map(task => ({ value: task.slug, label: `${task.phase_type} - ${task.name}` })),
);

export default connect(
  state => ({ loaded: state.tasks.loaded, options: getTaskOptions(state) }),
  { requestTaskList },
)(TaskSelect);



// WEBPACK FOOTER //
// ./client/app/shared/components/formElements/TaskSelect/index.jsx